import { useState, useEffect, useCallback } from 'react';
import apiClient from '../../../api/apiClient';

export const useDashboardOrders = () => {
    const [stats, setStats] = useState(null);
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchAllData = useCallback(async () => {
        setLoading(true);
        try {
            const [statsRes, ordersRes] = await Promise.all([
                apiClient.get('/api/pedidos/stats-finance'),
                apiClient.get('/api/pedidos/completo')
            ]);

            const allOrders = ordersRes.data.data || [];
            
            // Variáveis de controle
            let numeroDePedidosEsteira = 0;
            let numeroDePedidosConcluidos = 0;
            let numeroDePedidosGerais = 0;
            let receitaEsteira = 0;
            let receitaConcluidos = 0;
            let receitaGeral = 0;

            const mesAtual = new Date().getMonth();
            const anoAtual = new Date().getFullYear();

            allOrders.forEach(o => {
                const isConcluido = o.status === 'CONCLUIDO';
                const isCancelado = o.status === 'CANCELADO';
                
                // Ignorar cancelados nas métricas gerais de receita ativa
                if (isCancelado) return;

                // Validar se é do mês (para concluídos)
                if (isConcluido) {
                    const dataConclusao = new Date(o.dataConclusao || o.updatedAt || o.createdAt);
                    if (dataConclusao.getMonth() === mesAtual && dataConclusao.getFullYear() === anoAtual) {
                        numeroDePedidosConcluidos++;
                    } else {
                        return; // Se não for deste mês, ignora na contagem de concluídos
                    }
                } else {
                    numeroDePedidosEsteira++;
                }

                numeroDePedidosGerais++;

                const valorPedido = o.itens?.reduce((acc, it) => acc + ((it.quantidade || 0) * (it.precoUnitario || 0)), 0) || 0;

                receitaGeral += valorPedido;
                if (isConcluido) {
                    receitaConcluidos += valorPedido;
                } else {
                    receitaEsteira += valorPedido;
                }
            });

            // Projeção baseada na receita da esteira + concluídos (por exemplo, payout = receita * 4.5)
            const receitaProjecao = receitaGeral * 4.5;

            const dashMetrics = {
                ...statsRes.data.metrics,
                numeroDePedidosEsteira,
                numeroDePedidosConcluidos,
                numeroDePedidosGerais,
                receitaEsteira,
                receitaConcluidos,
                receitaGeral,
                receitaProjecao
            };

            setStats(dashMetrics);
            setOrders(allOrders);
        } catch (err) {
            console.error("🚩 [DASH-ENGINE-FAIL]: Falha no uplink de pedidos.");
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => { fetchAllData(); }, [fetchAllData]);

    return { stats, orders, loading, refresh: fetchAllData };
};